import styled from 'styled-components/macro';

import { definitionLabel } from 'styles/base-classes';
import modularScale from 'styles/helpers/modular-scale';
import { CellContent } from 'components/data-visualization/Table/DoubleMetricCell.style';

interface IProps {
  [key: string]: any;
  isRightAligned?: boolean;
}

export const HorizontalScrollContainer = styled.div`
  @media screen and (max-width: 40em) {
    overflow-x: auto;
    overflow-y: visible;
  }
`;

export const TableHeader = styled('th')<IProps>`
  ${definitionLabel};
  font-weight: 400;
  text-align: ${(p): string => (p.alignRight ? 'right' : 'left')};
  padding: ${({ theme }): string => theme.spacing.xsmall};
  ${({ fixedWidth }): string => (fixedWidth ? `width: ${fixedWidth};` : '')};
  ${({ wowRow }): string =>
    wowRow
      ? `display: flex;
  text-align: center;
  justify-content: flex-end;`
      : ''}
  &:last-child {
    ${({ isRightAligned }): string =>
      isRightAligned ? 'text-align: right;' : ''};
    @media screen and (min-width: 960px) {
      ${({ minWidth }): string => (minWidth ? `min-width: ${minWidth};` : '')}
    }
  }
`;

export const TitleTableCell = styled.td`
  text-transform: capitalize;
  font-weight: 600;
  color: ${(p): string => p.theme.NightBlue};
  display: flex;
  align-items: center;
  svg,
  div {
    margin-right: 0.3em;
  }
`;

export const Thead = styled.thead`
  vertical-align: bottom;
`;

export const TableRow = styled('tr')<IProps>`
  font-family: ${(p): string => p.theme.numbersTypography};
  font-size: ${modularScale(-1)};

  td {
    padding: ${({ theme }): string =>
      `${theme.spacing.xsmall} ${theme.spacing.xsmall} ${theme.spacing.xsmall}`};
  }

  ${CellContent} {
    @media screen and (min-width: 50em) {
      ${({ isRightAligned }): string =>
        isRightAligned
          ? `justify-content: flex-end;`
          : 'justify-content: flex-start;'};
    }
  }
`;
